// useNumberInput.js
import { useEffect } from 'react';

const useNumberInput = (inputRef) => {
  const handleKeyDown = (e) => {
    // Regular expression to match only numbers
    const numberPattern = /^[0-9-]$/;
        // List of allowed keys including navigation and editing keys
    const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Backspace', 'Delete'];

    if (!numberPattern.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', handleKeyDown);
      return () => {
        inputRef.current.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [inputRef]);

  return handleKeyDown;
};

export default useNumberInput;
